import React, { useState, useEffect } from 'react';
import ColorPickerTwitter from './components/ui/ColorPickerTwitter';

export default function ZoneDialog({
  initialName = '',
  initialColor = '#28a745',
  onSave,
  onCancel,
  onDelete,
  show = false
}) {
  const [name, setName] = useState(initialName);
  const [color, setColor] = useState(initialColor);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [pickerPosition, setPickerPosition] = useState({top: 38, left: 0});
  const swatchRef = React.useRef();
  const pickerRef = React.useRef();

  useEffect(() => {
    setName(initialName);
    setColor(initialColor);
  }, [initialName, initialColor, show]);

  // Dynamically position the picker so it's entirely visible in viewport
  useEffect(() => {
    if (!showColorPicker) return;
    function positionPicker() {
      if (!swatchRef.current || !pickerRef.current) return;
      const swatchRect = swatchRef.current.getBoundingClientRect();
      const pickerRect = pickerRef.current.getBoundingClientRect();
      const padding = 6;
      let top = swatchRect.bottom + padding;
      let left = swatchRect.left;
      // Check if overflowing bottom, move above swatch
      if (top + pickerRect.height > window.innerHeight) {
        top = swatchRect.top - pickerRect.height - padding;
      }
      // If overflowing right, shift left
      if (left + pickerRect.width > window.innerWidth) {
        left = window.innerWidth - pickerRect.width - padding;
      }
      // If overflowing left, shift right
      if (left < 0) left = padding;
      // If overflowing top, force below
      if (top < 0) top = swatchRect.bottom + padding;
      setPickerPosition({top: Math.max(top, 0), left: Math.max(left, 0)});
    }
    setTimeout(positionPicker, 10); // Wait for picker to render
    window.addEventListener('resize', positionPicker);
    return () => window.removeEventListener('resize', positionPicker);
  }, [showColorPicker]);

  // Close the color picker on outside click
  useEffect(() => {
    if (!showColorPicker) return;
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)
          && swatchRef.current && !swatchRef.current.contains(event.target)) {
        setShowColorPicker(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showColorPicker]);

  if (!show) return null;

  return (
     <div style={{
       position: 'fixed',
       top: 50,
       right:0,
       zIndex: 10000,
       background: '#494949',
       padding: "10px 24px",
       width: "100vw",
       display: 'flex',
       flexDirection: 'row',
       gap: 10,
       justifyContent: 'right',
       alignItems: 'flex-start',
     }}>

      <label style={{fontSize:14}}>
        {/* <span style={{fontWeight:"bold"}}>Name</span> */}
        <input value={name} onChange={e => setName(e.target.value)} placeholder="Zone name" style={{ marginLeft: 8, padding: 10, height: 30, width: 200, backgroundColor: "#2d2d2d", borderRadius:0 }} />
      </label>
      <label style={{fontSize:14, position: 'relative', display: 'flex', alignItems: 'center', marginLeft: 8 }}>
        {/* <span style={{fontWeight:"bold"}}>Color</span> */}
        <div
          ref={swatchRef}
          onClick={() => setShowColorPicker(true)}
          tabIndex={0}
          role="button"
          aria-label="Select color"
          style={{
            width: 30,
            height: 30,
            background: color,
            border: '2px solid #2d2d2d',
            borderRadius: 4,
            cursor: 'pointer',
            marginRight: 6,
            boxShadow: '0 0 4px rgba(0,0,0,0.17)'
          }}
        />
        {showColorPicker && (
          <div
            ref={pickerRef}
            id="color-picker-twitter-popup"
            style={{
              position: 'fixed',
              top: pickerPosition.top,
              left: pickerPosition.left,
              zIndex: 9999,
              boxShadow: '0 4px 16px rgba(0,0,0,.23)',
              background: '#fff',
              borderRadius: 6
            }}
          >
            <ColorPickerTwitter
              color={color}
              onChange={c => {
                setColor(c.hex);
                setShowColorPicker(false);
              }}
              triangle="hide"
            />
          </div>
        )}
      </label>
      <div style={{ display: 'flex', gap: 12, borderLeft: "1px solid #ffffff" }}>
        <button style={{ height: 30, padding: "0px 10px", background: '#28a745', color: '#fff', border: 'none', marginLeft: 14 }} onClick={() => onSave(name, color)}>Save</button>
        <button style={{ height: 30, padding: "0px 10px", background: '#000', color: '#fff', border: 'none' }} onClick={onCancel}>Cancel</button>
         {onDelete && (
           <button style={{ height: 30, padding: "0px 10px", background: '#dc3545', color: '#fff', border: 'none', marginLeft: 12 }} onClick={onDelete}>Delete</button>
         )}
       </div>
    </div>
  );
}
